module.exports = __webpack_public_path__ + "fonts/HarmonyOS_Sans_Bold.06fb3d4b.ttf";